export class RelatedTerritory {
    id: string;
    name: string;
}